import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('attPlans');

export const getAllAttPlans = (state) => {
  const plans = getResources(state, 'fetchAllPlans');
  plans.sort((a, b) => {
    if (
      typeof a.ordering === 'undefined' &&
      typeof b.ordering === 'undefined'
    ) {
      return 0;
    } else if (a.ordering > b.ordering) {
      return 1;
    } else if (a.ordering < b.ordering) {
      return -1;
    } else {
      return 0;
    }
  });
  return plans;
};
export const getAttPlan = (state, id) => state.resources[id];
